import { Pipe,Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Pipe({ name: 'AuthGuard' })
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {        
      if (sessionStorage.getItem('auth')) {
            // logged in so return true
            let stringArrayUrl: any = sessionStorage.getItem('arrayUrl');
            if (stringArrayUrl.trim() !== "") {
              let arrayUrl: Array<string> = stringArrayUrl.split(',');
              if (arrayUrl.length > 0 && arrayUrl[arrayUrl.length-1] != state.url) {
                arrayUrl.push(state.url);
                sessionStorage.setItem('arrayUrl', arrayUrl.toString());
              }
            } else {
              //thêm url đầu tiên khi mới đăng nhập vào
              let arrayUrl: Array<string> = [];
              arrayUrl.push(state.url);
              sessionStorage.setItem('arrayUrl', arrayUrl.toString());
            }
            
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/auth.guard.ts